import { useCallback, useState, type ChangeEvent } from 'react'
import { Button, Card, Form, Input } from 'antd'
import { LockOutlined } from '@ant-design/icons'

export const LoginForm = ({ pending, onLogin }: {
  pending: boolean; onLogin: (username: string, credential: string) => Promise<void>
}) => {
  const [username, setUsername] = useState('')
  const [credential, setCredential] = useState('')
  const changeUsername = useCallback((event: ChangeEvent<HTMLInputElement>) => setUsername(event.target.value), [])
  const change = useCallback((event: ChangeEvent<HTMLInputElement>) => setCredential(event.target.value), [])
  const submit = useCallback(() => {
    const value = credential
    setCredential('')
    void onLogin(username.trim(), value)
  }, [credential, onLogin, username])
  return <Card className="instance-administration__login-card">
    <div className="instance-administration__login-mark"><LockOutlined /></div>
    <h1>管理员登录</h1>
    <Form layout="vertical" onFinish={submit} disabled={pending}>
      <Form.Item label="账号" htmlFor="instance-administrator-username">
        <Input id="instance-administrator-username" name="username" aria-label="账号" autoComplete="username"
          required value={username} onChange={changeUsername} size="large" />
      </Form.Item>
      <Form.Item label="密码" htmlFor="instance-administrator-credential">
        <Input.Password id="instance-administrator-credential" name="password" aria-label="密码" autoComplete="current-password"
          required value={credential} onChange={change} size="large" />
      </Form.Item>
      <Button type="primary" htmlType="submit" loading={pending} disabled={pending} size="large" block>登录</Button>
    </Form>
  </Card>
}
